import { ItemType } from '@weareopenr/types';
import { IUpdatedOptionsPayload, IUpdateOptionGroupRequestBody } from 'src/api/updateOptionGroup/types';
import { IOptionGroupValues } from 'src/components/CreateOptionGroupModal/types';
import { EntitySource } from 'src/constants';
import { IMenuItem, IOptionGroup } from 'src/types/menu.types';

export const getOptionGroupDefaultValues = (optionGroup: IOptionGroup, item?: IMenuItem): IOptionGroupValues => {
  return {
    name: optionGroup.name,
    consumer_name: optionGroup.consumer_name,
    description: optionGroup.description,
    min_choices: Number(optionGroup.min),
    max_choices: Number(optionGroup.max),
    modifiers: optionGroup?.items.map((item) => ({
      name: item.name,
      optionItemId: item.optionItemId,
      itemId: item.optionItemId,
      posId: item.posId,
      valueWithTax: item.valueWithTax ?? null,
      useDefaultPrice: item.inheritPrice,
      inheritPosId: !item.posId,
      min: item.min ?? null,
      max: item.max ?? null,
      default: item.default ?? null,
    })),
    ranges:
      item && item.type === ItemType.BUNDLE && item.ranges
        ? item.ranges.map((range) => range.range_id)
        : optionGroup.ranges.map((range) => range.range_id),
    source: optionGroup.ranges.length > 0 ? EntitySource.RANGES : EntitySource.LIBRARY,
    externalSystems: optionGroup.external_systems.map((extSys) => extSys.external_system_id),
  };
};

export const formatUpdateOptionGroupRequestBody = (
  data: IOptionGroupValues,
  itemId?: string,
): IUpdateOptionGroupRequestBody => {
  return {
    description: data.description || null,
    consumer_name: data.consumer_name || null,
    max_choices: data.max_choices,
    min_choices: data.min_choices,
    options: data.modifiers.map(
      (modifier): IUpdatedOptionsPayload => ({
        item_id: modifier.optionItemId,
        plu: modifier.inheritPosId ? null : modifier.posId || null,
        value_with_tax: modifier.useDefaultPrice ? null : modifier.valueWithTax,
        min_choices: modifier.min ?? null,
        max_choices: modifier.max ?? null,
        default_choice: modifier.default ?? null,
      }),
    ),
    name: data.name,
    external_systems: data.externalSystems,
    ...(itemId && { item_id: itemId }),
  };
};
